import React from "react";
import { TrendingUp, TrendingDown, Sparkles } from "lucide-react";
import Avatar from "./Avatar";

export default function TrendCard({ index, onClick, selected, captain, vc, livePulse }) {
  const change = index.change_24h ?? 0;
  const up = change >= 0;
  const points = Number(index.form_points ?? index.heat_score ?? 0);
  return (
    <button
      type="button"
      data-testid={`trend-card-${index.handle}`}
      onClick={onClick}
      className={`text-left w-full rounded-2xl glass card-hover p-3 relative overflow-hidden ${selected ? "ring-2 ring-[#00F0FF]" : ""}`}
    >
      <div className="flex items-center gap-3">
        <Avatar name={index.name} category={index.category} symbol={index.symbol} size={56} rounded={16} />
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 flex-wrap">
            <p className="font-display text-base font-semibold truncate">{index.name}</p>
            {captain && <span className="chip text-[9px]" style={{ background: "#FFD60022", color: "#FFD600", border: "1px solid #FFD60055" }}>C 2×</span>}
            {vc && <span className="chip text-[9px]" style={{ background: "#00F0FF22", color: "#00F0FF", border: "1px solid #00F0FF55" }}>VC 1.5×</span>}
          </div>
          <p className="text-[11px] uppercase tracking-widest text-white/40 mt-0.5 truncate">
            {index.category}{index.subtype ? ` · ${index.subtype}` : ""} · @{index.handle}
          </p>
          <div className="mt-1.5 flex items-center gap-2">
            <span
              className={`inline-flex items-center gap-1 text-[10px] font-bold tracking-wider uppercase ${up ? "text-[#00FF66]" : "text-[#FF0055]"}`}
              data-testid={`trend-form-${index.handle}`}
            >
              {up ? <TrendingUp className="w-3 h-3" /> : <TrendingDown className="w-3 h-3" />}
              Form {up ? "+" : ""}{change.toFixed(1)}%
            </span>
          </div>
        </div>
        <div className="shrink-0 text-right">
          <p className={`font-display text-xl font-bold leading-none ${livePulse ? "pop" : ""}`} style={{ color: "#FFD600" }}>
            {points}
          </p>
          <p className="text-[9px] uppercase tracking-widest font-bold text-white/45 mt-0.5">pts</p>
        </div>
      </div>
      {Array.isArray(index.form_breakdown) && index.form_breakdown.length > 0 && (
        <div className="mt-2.5 flex items-center gap-1.5 text-[10px] text-white/55">
          <Sparkles className="w-3 h-3 text-[#B026FF]" />
          <span className="truncate">{index.form_breakdown[0].label}</span>
          <span className={`font-mono-brand ml-auto shrink-0 ${index.form_breakdown[0].points >= 0 ? "text-[#00FF66]" : "text-[#FF0055]"}`}>
            {index.form_breakdown[0].points >= 0 ? "+" : ""}{index.form_breakdown[0].points}
          </span>
        </div>
      )}
    </button>
  );
}
